import { render, staticRenderFns } from "./listado_de_evaluaciones_eliminadas_movil.vue?vue&type=template&id=5338347a"
import script from "./listado_de_evaluaciones_eliminadas_movil.vue?vue&type=script&lang=js"
export * from "./listado_de_evaluaciones_eliminadas_movil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports